import React from "react";

function useFormatters() {
  const formatCurrency = React.useCallback((num) => {
    if (num === null || num === undefined) {
      return "";
    }

    return new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
    }).format(num);
  }, []);

  return {
    formatCurrency,
  };
}

export default useFormatters;
